const initialState = {
  Parameters: null,
  ImageCountNeedToImport : 0
}

export default function overlappingParametersReducer(
    
  state = initialState,
  action: any
) {
  switch (action.type) {
    case "OVER_LAPPING_PARAMETERS":
      return {
        ...state,
        

        Parameters: action.payload.Parameters,
        
      }
    default:
      return state
  }
}
